import React from 'react';
import PropTypes from 'prop-types';

import styles from './styled';
import BottomSheet from '../../../blocks/BottomSheet';

const ConfirmationSheet = ({
  bodyText,
  bottom,
  buttons,
  visible,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <BottomSheet
      bottom={bottom}
      visible={visible}
    >
      <styles.Wrapper>
        <styles.BodyText>
          {bodyText}
        </styles.BodyText>
        <styles.ActionWrap>
          {buttons.map((data) => (
            <BottomSheet.ActionButton
              modifiers={[data.type]}
              onClick={data.clickHandler}
            >
              {data.text}
            </BottomSheet.ActionButton>
          ))}
        </styles.ActionWrap>
      </styles.Wrapper>
    </BottomSheet>
  );
};

ConfirmationSheet.propTypes = {
  bodyText: PropTypes.string.isRequired,
  bottom: PropTypes.number,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    clickHandler: PropTypes.func.isRequired,
    type: PropTypes.oneOf([
      'success',
      'plain',
      'primary',
      'danger',
    ]),
  })).isRequired,
  visible: PropTypes.bool.isRequired,
};

ConfirmationSheet.defaultProps = {
  bottom: 40,
};

export default ConfirmationSheet;
